import React from 'react'

const AccountLazySentinel = ({ sentinelRef, hasMore }) => {
  if (!hasMore) return null

  return <div ref={sentinelRef} className="h-6 w-full" aria-hidden />
}

export default AccountLazySentinel
